module.exports = __webpack_public_path__ + "img/Divii-Lawyers-Primary.29b584c3.png";